var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.574 6.507-2.08-2.078A1.462 1.462 0 0 0 16.456 4c-.376 0-.751.14-1.04.429l-8.303 8.308C6.537 13.312 4 20 4 20s6.694-2.542 7.264-3.112l8.304-8.302a1.472 1.472 0 0 0 .006-2.079Zm-.523 1.556-8.286 8.285c-.37.293-2.86 1.344-5.485 2.372 1.028-2.625 2.073-5.114 2.355-5.466l8.304-8.303a.733.733 0 0 1 .516-.211c.2 0 .382.076.517.211l2.079 2.079a.726.726 0 0 1 0 1.033Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.41 14.03 7.786-7.785.52.519-7.786 7.784zm1.04 1.038 7.786-7.785.52.52-7.786 7.784z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.f43ed1262997b660b50119478856ee6f.svg";
export { ForwardRef as ReactComponent };